export const NIGHTS_RANGE_TEXTS = {
  fieldLabel: 'Кол-во ночей',
  valuePrefix: 'на ',
  fromLabel: 'От',
  toLabel: 'До',
  summaryPrefix: 'Выбраны туры с ',
  summaryMid: ' на ',
} as const;
